import { createFileRoute, Link } from "@tanstack/react-router";
import { abrirPreferencias } from "@/lib/consent";

export const Route = createFileRoute("/cookies")({
  component: Cookies,
  head: () => ({
    meta: [
      { title: "Política de cookies | Pyme Visible" },
      {
        name: "description",
        content:
          "Qué almacenamiento usa el sitio de Pyme Visible, cuándo se activa Google Analytics o el mapa de Google y cómo cambiar tus preferencias.",
      },
      { property: "og:title", content: "Política de cookies | Pyme Visible" },
      {
        property: "og:description",
        content:
          "Almacenamiento necesario, analítica y contenido externo en el sitio de Pyme Visible.",
      },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_CL" },
      { property: "og:url", content: "https://pymevisible.cl/cookies" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Política de cookies | Pyme Visible" },
      {
        name: "twitter:description",
        content: "Cómo aceptar, rechazar o cambiar el uso de analítica y mapa en Pyme Visible.",
      },
    ],
    links: [{ rel: "canonical", href: "https://pymevisible.cl/cookies" }],
  }),
});

function Cookies() {
  return (
    <main id="contenido" lang="es-CL" className="pv-legal-page mx-auto max-w-3xl px-5 py-20">
      <Link to="/" className="text-sm font-medium text-primary underline">
        ← Volver al inicio
      </Link>
      <h1 className="mt-6 text-3xl font-extrabold text-navy sm:text-4xl">Política de cookies</h1>

      <div className="pv-legal-copy mt-8 grid gap-8 leading-relaxed text-muted-foreground">
        <p>Última actualización: 9 de septiembre de 2026.</p>
        <p>
          Utilizamos cookies y tecnologías similares para el funcionamiento del sitio, recordar
          preferencias y comprender de forma agregada cómo se utiliza la página. Puedes configurar
          tu navegador para bloquear o eliminar cookies; esto podría afectar algunas funciones del
          sitio.
        </p>

        <section>
          <h2 className="text-xl font-bold text-navy">Almacenamiento estrictamente necesario</h2>
          <p className="mt-3">
            Guardamos en tu navegador (almacenamiento local) únicamente la elección que haces en el
            aviso de privacidad, para recordarla en tus próximas visitas. Este almacenamiento no
            requiere aceptación porque sin él no podríamos respetar tu decisión.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Analítica (Google Analytics 4)</h2>
          <p className="mt-3">
            Google Analytics sólo se carga si aceptas la categoría de analítica. Mientras no
            aceptes, el script no se descarga y no se envían eventos. Al activarlo, Google puede
            tratar tu dirección IP e identificadores del navegador o dispositivo.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Contenido externo (Google Maps)</h2>
          <p className="mt-3">
            El mapa incrustado en el pie de página sólo se muestra si eliges cargar contenido
            externo. Mientras tanto verás un aviso con un botón para cargarlo y un enlace para abrir
            el mapa directamente en Google, que es una acción voluntaria tuya. Al cargar el mapa,
            Google puede tratar tu dirección IP e identificadores.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-navy">Cómo aceptar, rechazar o cambiar</h2>
          <p className="mt-3">
            Puedes abrir el panel en cualquier momento desde el enlace “Preferencias de privacidad”
            del pie de página, o aquí mismo:
          </p>
          <button
            type="button"
            onClick={abrirPreferencias}
            className="pv-button pv-button--primary mt-4 min-h-11 px-5 py-2.5 text-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy"
          >
            Abrir preferencias de privacidad
          </button>
          <p className="mt-4">
            Si retiras tu consentimiento, evitamos futuras cargas de esos servicios. Las cookies que
            esos proveedores ya hubieran dejado en tu navegador puedes gestionarlas o eliminarlas
            desde la configuración del propio navegador.
          </p>
        </section>
      </div>
    </main>
  );
}
